export default {
    title: "立即更新教師帳戶，賺取豐富現金券!",
    joinedTitle: "您已成功參加更新教師帳戶活動！",
    joinedMessage: "📧 獎賞將於完成更新及經教城核實後，預計數星期內發放到您的學校電郵信箱。處理需時，感謝您的耐心等候。",
    referralCode: "您的推薦碼：",
    numberOfReferrals: "成功推薦人數：",
    components: {
        start: {
            description: "輕鬆完成資料核實，即可參與活動，賺取豐富現金券！流程簡單快捷，立即行動，解鎖專屬教師禮遇！",
            wrongAccountAlert: "你目前登入的帳戶為<b>個人教師帳戶</b>。<br>如欲參與此活動，請以<b>校本教師帳戶</b>重新登入。<br>如忘記校本帳戶登入資訊，請聯絡所屬學校行政人員。",
            requirement: {
                title: "參加條件",
                list: [
                    "<b>訂閱教城資訊</b> – 最少剔選一項",
                    "<b>填寫教師身分資料</b> – 三個必填欄位：主要任教科目、主要校內職務、關注項目​",
                ]
            },
            reward: {
                title: "優惠券機制",
                list: [
                    "每位完成更新的老師：<b>$20 7-11 現金券</b>",
                ]
            },
            referral: {
                title: "推薦制度​",
                list: [
                    "完成驗證後獲得獨立推薦碼​",
                    "每成功推薦 <b>3</b> 人完成驗證，額外獲 <b>$10 7-11 現金券​</b>",
                    "每位推薦人上限：成功推薦 <b>9</b> 人（最多獲 $30）"
                ]
            },
            period:{
                title: "活動日期：",
                list: [
                    "{startDate} 至 {endDate}"
                ]
            }
        },
        
        referral: {
            description: "輸入推薦人的推薦碼，以享受相關優惠。若沒有推薦碼，您可直接按下一步。",
            input: {
                referralCode: {
                    label: "推薦碼(選填)",
                    error:{
                       improper: "推薦碼無效，請重新輸入。",
                       invalid: "推薦碼格式錯誤，請確認後再試。",
                    }   
                },
            }
        },
        subscription:{
            description: "請選擇您想訂閱的教城資訊，至少選擇一項以繼續參加活動。",
        },        
        subjects:{
            description: "請選擇您填寫教師身分資料中的「主要任教科目」以繼續參加活動。",
        },        
        duties:{
            description: "請選擇您填寫教師身分資料中的「主要校內職務」以繼續參加活動。",
        },        
        interests:{
            description: "請選擇您填寫教師身分資料中的「關注項目​」以繼續參加活動。",
        },
        finish:{
            message: "完成!",
            errorMessage: "發生錯誤，請稍後再試。",
            shareMessage: "立即分享給其他老師，邀請他們一起參加活動，解鎖更多獎賞！​",            
            share: {
                copy:{
                    title: "已複製推薦碼",
                },
                copyLink:{
                    title: "已複製推薦連結",
                },
                instantMessage:{
                    title: "立即更新香港教育城（教城）校本教師帳戶，賺取豐富現金券！",
                    content: "只需輕鬆完成資料核實，即可參與活動，賺取現金券。流程簡單快捷，立即行動，解鎖專屬教師禮遇！​推薦碼: "
                },
                email: {
                subject: "{fullname} 想邀請您於教城更新教師帳戶，賺取豐富現金券",
                content: "您好! \n \n 我想邀請您於香港教育城（教城）更新教師帳戶，賺取豐富現金券。請點擊以下連結，登入校本教師帳戶後即可更新教師帳戶：\n {campaignLink} ",
                },
            },
        }
    },
    button: {
        join: "立即參加",
        skip: "跳過",
        share: "分享推薦碼",
        cancel: "取消",
        next: "下一步",
        copy:"複製邀請連結",
        email: "電郵邀請",
        close: "關閉",
        learnMore: "了解活動詳情​",
        loginAgain: "重新登入"
    },
    stepTitle: {
        referree: "推薦碼",
        subscription: "訂閱教城資訊",
        teacherProfile: "填寫教師身分資料",
        questionnaire: "問卷調查",
        complete: "完成",
    },

  questionnaire: {
    other: "其他",
    errors: {
      required: "此問題為必填項。",
      otherRequired: "請填寫其他項內容。",
    },
    groups: [
      {
        title: "一、對教城活動或服務的認識程度",
        questions: [
          {
            title: "1. 請評估您對以下教城活動或服務的認識程度（1分為完全不了解，5分為非常了解）",
            subtitle: "活動或服務",
            options: [
              { label: "學與教博覽（LTE）" },
              { label: "「數字教育教師專業培訓」系列內的研討會或工作坊" },
              { label: "教學資源庫（RD）" },
              { label: "網上學習、教學與評估平台（STAR）" },
              { label: "網上試題學習平台（OQB）" },
              { label: "Go e-Learning" },
              { label: "數字教育資源網站" },
              { label: "一站式教育科技平台（EdMarket）" },
              { label: "電子學習配套計劃（eLAFP）" },
              { label: "PICCKS 學生獎勵計劃" },
              { label: "國民身份認同應用程式設計比賽（NI）" },
              { label: "創意演說比賽（CSC）" },
              { label: "學生創新大賽（SIC）" },
              { label: "香港閱讀城" },
              { label: "e悅讀學校計劃" },
              { label: "小校園" },
              { label: "教城教師應用程式「EdCity Teacher」" },
              { label: "教城學生應用程式「EdCity Student」" },
              { label: "教城家長應用程式「EdCity Parent」" },
              { label: "家長講座" }
            ]
          }
        ]
      },
      {
        title: "二、滿意度",
        questions: [
          {
            title: "2. 您對教城現有的活動及服務是否滿意？",
            options: [
              { label: "非常滿意" },
              { label: "滿意" },
              { label: "一般" },
              { label: "不滿意" },
              { label: "非常不滿意" }
            ]
          }
        ]
      },
      {
        title: "三、學生服務與活動期望",
        questions: [
          {
            title: "3. 您希望教城為學生提供哪些主題的活動或服務？（可選多項）",
            groups: [
              {
                subtitle: "科技與數字素養",
                options: [
                  { label: "AI／人工智能基礎與應用" },
                  { label: "編程／運算思維" },
                  { label: "網絡安全／數字公民素養" },
                  { label: "多媒體創作（影片、動畫、網頁設計等）" },
                  { label: "機械人／STEM／STEAM" }
                ]
              },
              {
                subtitle: "學術與語言",
                options: [
                  { label: "科學探究" },
                  { label: "數學思維" },
                  { label: "閱讀及寫作" },
                  { label: "語言學習（如英語及普通話）" }
                ]
              },
              {
                subtitle: "未來規劃與價值觀",
                options: [
                  { label: "升學輔導" },
                  { label: "國民身份認同／中華文化" },
                  { label: "理財教育" },
                  { label: "價值觀教育（堅毅、誠信、責任感等）" }
                ]
              },
              {
                subtitle: "身心健康",
                options: [
                  { label: "心理健康／情緒管理" },
                  { label: "體育" },
                  { label: "健康飲食與生活" }
                ]
              },
              {
                subtitle: "其他",
                options: []
              }
            ]
          },
          {
            title: "4. 您希望教城未來採用哪些形式舉辦學生活動？（可選多項）",
            groups: [
              {
                subtitle: "線上形式",
                options: [
                  { label: "網上工作坊" },
                  { label: "網上研討會" },
                  { label: "網上比賽" },
                  { label: "自學課程（影片／教材）" }
                ]
              },
              {
                subtitle: "線下形式",
                options: [
                  { label: "實體工作坊" },
                  { label: "實體講座" },
                  { label: "比賽" },
                  { label: "企業參觀（本地）" },
                  { label: "企業參觀（內地／海外）" },
                  { label: "戶外學習日" }
                ]
              },
              {
                subtitle: "混合及其他形式",
                options: [
                  { label: "線上＋線下混合模式" },
                  { label: "遊戲化學習活動" },
                  { label: "模擬體驗（如模擬社會及模擬法庭）" }
                ]
              },
              {
                subtitle: "其他",
                options: []
              }
            ]
          }
        ]
      },
      {
        title: "四、教師專業發展活動期望",
        questions: [
          {
            title: "5. 您對以下哪些主題的教師專業發展活動感興趣？（可選多項）",
            groups: [
              {
                subtitle: "教學與科技",
                options: [
                  { label: "AI 教學工具與應用" },
                  { label: "教育科技趨勢與創新" },
                  { label: "AI 數字素養" },
                  { label: "數據分析與評估" },
                  { label: "電子學習資源設計" }
                ]
              },
              {
                subtitle: "專業技能提升",
                options: [
                  { label: "課程設計與開發" },
                  { label: "創新教學法（如自主學習及翻轉教室）" },
                  { label: "評估與考評策略" },
                  { label: "教師管理" },
                  { label: "學校行政管理" },
                  { label: "教育政策與發展" }
                ]
              },
              {
                subtitle: "學生支援",
                options: [
                  { label: "課堂管理" },
                  { label: "心理健康／學生輔導" },
                  { label: "生涯規劃教育" },
                  { label: "特殊教育（SEN）" }
                ]
              },
              {
                subtitle: "價值與視野",
                options: [
                  { label: "國民教育／國家安全" },
                  { label: "媒體與資訊素養" },
                  { label: "國際視野" },
                  { label: "教師身心靈健康（如壓力管理及工作生活平衡）" }
                ]
              },
              {
                subtitle: "其他",
                options: []
              }
            ]
          },
          {
            title: "6. 您對以下哪些活動形式感興趣？（可選多項）",
            groups: [
              {
                subtitle: "線下形式",
                options: [
                  { label: "實體工作坊" },
                  { label: "實體講座／研討會" },
                  { label: "本地企業參觀及交流" },
                  { label: "內地企業參觀及交流" },
                  { label: "學界同工交流分享會" },
                  { label: "方案展示日" }
                ]
              },
              {
                subtitle: "線上形式",
                options: [
                  { label: "網上研討會" },
                  { label: "網上工作坊" },
                  { label: "自學課程（影片／教材）" }
                ]
              },
              {
                subtitle: "混合及其他形式",
                options: [
                  { label: "線上＋線下混合模式" },
                  { label: "教師社群小組" }
                ]
              },
              {
                subtitle: "其他",
                options: []
              }
            ]
          }
        ]
      },
      {
        title: "五、開放式意見（可選填）",
        questions: [
          {
            title: "7. 您對教城未來的活動或服務有甚麼建議或想法？"
          }
        ]
      }
    ]
  }
}